import React from "react";
import NavbarTop from "../components/NavbarTop";
import NavbarBottom from "../components/NavbarBottom";
import ScanDevice from "../components/ScanDevice";

const HomePage = () => {
  return (
    <div>
      <NavbarTop />
      <ScanDevice />
      <NavbarBottom />
    </div>
  );
};

export default HomePage;
